<div class="grid pt-5">
  <div class="col" style="max-width: 100%">
    <p-floatLabel>
      <p-inputNumber
        id="temporalWindowSizeSelector"
        inputId="windowSizeSelectorInput"
        [showButtons]="true"
        [maxFractionDigits]="0"
        [suffix]="(temporalMatchingModel.size$|async) === 1 ? ' hour' : ' hours'"
        [ngModel]="(temporalMatchingModel.size$|async) ? (temporalMatchingModel.size$|async) : getDefaultSize()"
        (ngModelChange)="temporalMatchingModel.size$.next($event)"
        [step]="1"
        [min]="1"
        [max]="24">
      </p-inputNumber>
      <label for="windowSizeSelectorInput">
        Select temporal window size
      </label>
    </p-floatLabel>
  </div>
</div>
